<template>
  <TechLayout>
    <div class="text-center p-3">
      <el-button-group>
        <el-button
          type="info"
          @click="$router.push('/tech')"
          style="outline:none"
          ><i class="el-icon-arrow-left"></i>技术资讯</el-button
        >
        <el-button
          type="info"
          @click="$router.push('/news')"
          style="outline:none"
          >新闻资讯<i class="el-icon-arrow-right el-icon--right"></i
        ></el-button>
      </el-button-group>
    </div>
    <!-- <tech-lisence/> -->
    <div class="mt-4">
      <b-card img-left class="" v-for="(item, index) in Tech" :key="index">
        <b-row>
          <b-col class="col-md-6 left-pic">
            <div v-if="item.tecImg">
              <b-img class="rounded-0 card-img" :src="item.tecImg"></b-img>
            </div>
            <div v-else>
              <b-img class="rounded-0 card-img" :src="coverPic.src"></b-img>
            </div>
          </b-col>
          <b-col class="right-desc col-md-6">
            <b-card-text
              style="border-bottom: 1px solid rgb(235, 238, 245);"
              @click="$router.push(`/techdetail/${item.tecId}`)"
            >
              <h3 class="art-title">{{ item.tecTitle }}</h3>
            </b-card-text>
            <b-card-text class="less-desc">
              {{ item.tecContent }}
            </b-card-text>
          </b-col>
        </b-row>
        <b-card-footer>
          <i class="el-icon-date">{{ item.day }}</i>
        </b-card-footer>
      </b-card>
    </div>
  </TechLayout>
</template>

<script>
import { postRequest } from "../main";
import TechLayout from "../layouts/TechNews";
// import techLisence from './techLisens.vue'
export default {
  components: {
    TechLayout,
  },
  data() {
    return {
      coverPic: { src: require("../../static/Updatedimg/Corp-3.jpg") },
      rows: 100,
      currentPage: 1,
      Tech: [
        {
          tecTitle: "4564",
          tecContent: "sdad",
        },
      ],
    };
  },
  methods: {
    getData() {
      postRequest("http://houtai.pioneertools.com/public/selectAllTec", {
        page: this.currentPage,
      }).then((res) => {
        // console.log(res);
        let data = res.data.data.list;
        for (let i = 0; i < data.length; i++) {
          let d = new Date(data[i].tecTime);
          data[i].day =
            d.getFullYear() + "-" + d.getMonth() + "-" + d.getDate();

          // data[i].tecContent = data[i].tecContent.substring(0,20)+"..."
        }
        this.Tech = data;
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style>
.updateTime {
  color: #999;
  font-size: 14px;
  padding-left: 0px;
}
.card {
  width: 100%;
  box-shadow: 2px 2px 2px #333;
}

.card-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  word-break: break-all;
}
.TechList {
  padding-top: 10px;
}
.pageIndex {
  margin: 0 auto;
}
.card,
.main-content .el-card {
  margin: 0 auto;
  margin-top: 10px;
}
.card {
  width: 890px;
  border-radius: 1rem !important;
  background: hsla(0, 0%, 100%, 0.7) !important;
}
@media (max-width: 500px) {
  .card {
    width: 360px;
  }

  .art-title {
    font-size: 18px;
  }
  .card-body {
    padding-bottom: 0.5rem !important;
  }
  .card img {
    padding: 0 !important;
  }
}
@media (max-width: 400px) {
  .card {
    width: 320px;
  }
}
@media (max-width: 340px) {
  .card {
    width: 300px;
  }
}
/* @media (max-width: 768px) {
       .card{
            width: 580px;
       }
    } */
.card img {
  padding: 10px;
  margin-top: 10px !important;
}
.art-title {
  -webkit-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
  cursor: pointer;
}
.art-title:hover {
  color: #f56c6c;
}
.less-desc {
  padding-top: 1rem;
  color: rgb(119, 119, 119);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.left-pic {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 40% !important;
  flex: 0 0 40% !important;
  max-width: 40% !important;
}
.right-desc {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 60% !important;
  flex: 0 0 60% !important;
  max-width: 60% !important;
}
.card-footer {
  padding: 0.75rem 1.25rem;
  background: none !important;
  color: rgb(119, 119, 119);
}
</style>
